<template>
  <el-scrollbar ref="scrollbar">
    <!-- 用 padding 撑起滚动条 -->
    <div :style="spacerStyle">
      <!-- 只画可视区域 -->
      <div
          v-for="(item, idx) in visibleItems"
          :key="startIdx + idx"
          :ref="setItemRef"
      >
        <slot :item="item" :index="startIdx + idx"/>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'VirtualScroller2',
  props: {
    items: { type: Array, required: true },
    size:  { type: Number, default: 30 },   // 每页条数（用于分页加载）
    itemHeight: { type: Number, default: 32 } // 单行高度，按需调整
  },
  data() {
    return {
      page: 1,
      lockTip: false,
      isInitEvent: false,

      /* 滚动相关 */
      scrollTop: 0,
      clientHeight: 0,
      rafId: null,
      itemRefs: []
    }
  },
  computed: {
    /* 可视区域起始 / 结束索引 */
    startIdx() {
      return Math.floor(this.scrollTop / this.itemHeight)
    },
    endIdx() {
      // 多渲染 2 行，防止留白
      return Math.min(
          this.startIdx + Math.ceil(this.clientHeight / this.itemHeight) + 2,
          this.items.length
      )
    },
    /* 真正渲染的数据 */
    visibleItems() {
      return this.items.slice(this.startIdx, this.endIdx)
    },
    /* 上下填充高度 */
    spacerStyle() {
      return {
        paddingTop: `${this.startIdx * this.itemHeight}px`,
        paddingBottom: `${(this.items.length - this.endIdx) * this.itemHeight}px`
      }
    }
  },
  watch: {
    /* 分页加载：当 endIdx 逼近已加载长度时自动下一页 */
    endIdx(val) {
      if (val >= this.page * this.size && val < this.items.length) {
        this.page++
      }
    }
  },
  mounted() {
    this.initEvent()
  },
  beforeDestroy() {
    if (this.rafId) cancelAnimationFrame(this.rafId)
  },
  methods: {
    initEvent() {
      if (this.isInitEvent) return
      const wrap = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap')
      wrap.addEventListener('scroll', this.onScroll, { passive: true })
      this.clientHeight = wrap.clientHeight
      this.isInitEvent = true
    },
    onScroll(e) {
      if (this.rafId) cancelAnimationFrame(this.rafId)
      this.rafId = requestAnimationFrame(() => {
        this.scrollTop = e.target.scrollTop
        this.clientHeight = e.target.clientHeight

        // 到底提示
        if (
            this.scrollTop + this.clientHeight >=
            e.target.scrollHeight - 30
        ) {
          if (this.endIdx >= this.items.length) this.showTip()
        }
      })
    },
    showTip() {
      if (this.lockTip) return
      this.$message.success('已滚动到底部')
      this.lockTip = true
      setTimeout(() => (this.lockTip = false), 3000)
    },
    // 新增方法：滚动到指定索引
    scrollToIndex(index) {
      this.$nextTick(() => {
        const targetScrollTop = index * this.itemHeight;
        const wrap = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap');
        if (wrap) {
          wrap.scrollTop = targetScrollTop;
        }
      });
    },
    // 辅助方法：设置元素引用
    setItemRef(el) {
      if (el) {
        this.itemRefs.push(el);
      }
    }
  }
}
</script>

<style scoped></style>
